import React from 'react';
import '../styles/homeTheme.css';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div
          className="ht-root fixed inset-0 z-[9999] flex items-center justify-center p-8 text-center"
          style={{ background: '#fdfdfc' }}
        >
          <div className="max-w-md">
            <p
              className="mb-4"
              style={{ fontFamily: 'var(--inter)', fontWeight: 700, fontSize: 11, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#b06a45' }}
            >
              Something broke
            </p>
            <h2
              className="mb-4"
              style={{ fontFamily: 'var(--hanken)', fontWeight: 700, fontSize: 'clamp(28px,5vw,40px)', lineHeight: 1.05, letterSpacing: '-0.03em', color: '#171718' }}
            >
              Something went <span className="aa-grad">wrong.</span>
            </h2>
            <p
              className="mb-8"
              style={{ fontFamily: 'var(--inter)', fontSize: 15, lineHeight: 1.6, color: '#57585b' }}
            >
              {this.state.error?.message || 'An unexpected error occurred.'}
            </p>
            <button onClick={() => window.location.reload()} className="ht-btn ht-btn-hero">
              Reload page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
